<template>
    <div class="rsya-item__container">
        <div class="rsy-item">
            <rsy-ad-img-container :disable-fancy="disableFancy" :ad-id="ad.id" :files="ad.files" :child-count="groupLength"/>
        </div>
        <div>
            <h6 v-text="ad.title" :title="ad.title" class="truncate_text em95 p-0 m-0"></h6>
            <p v-text="ad.second_title" class="rsy-item-titles truncate_text em80 p-0 m-0"></p>
            <p v-text="ad.body" :title="ad.body" class="rsy-item-titles truncate_text em80 p-0 m-0"></p>
        </div>
        <div class="rsya-item-info__container">
            <div class="rsya-item-info">
                <span v-html="`URL`"></span>
                <span class="truncate_text" style="max-width: 150px"><a :href="ad.target_url" target="_blank">{{ad.target_url}}</a></span>
            </div>
            <div class="rsya-item-info">
                <span v-html="$t('lang.report.rsy-ads.founded')"></span>
                <span v-html="ad.found_at" class="w400"></span>
            </div>
            <div class="rsya-item-info">
                <span v-html="$t('lang.report.rsy-ads.updated')"></span>
                <span v-html="ad.updated_at" class="w400"></span>
            </div>
            <div class="rsya-item-info">
                <span v-html="$t('lang.report.rsy-ads.diff_days.title')"></span>
                <span v-html="ad.diff_days" class="w400"></span>
            </div>
            <div class="rsya-item-info">
                <span v-html="$t('lang.report.rsy-ads.view_cnt.title')"></span>
                <span v-html="ad.view_cnt" class="w400"></span>
            </div>
            <div class="rsya-item-info">
                <span v-html="`ID`"></span>
                <span v-html="ad.id" class="w400"></span>
            </div>
            <div class="rsya-item-info">
                <span v-html="$t('lang.report.rsy-ads.type.title')"></span>
                <span v-text="ad.type" class="w400"></span>
            </div>
            <div class="rsya-item-info">
                <span v-html="$t('lang.report.rsy-ads.region.title')"></span>
                <span v-text="ad.region_name" class="w400"></span>
            </div>
            <div class="rsya-item-info">
                <span v-html="$t('lang.report.rsy-ads.legal.title')"></span>
                <span @click="showLegalInfo = true" class="rsya-toogle-button">{{ $t('lang.main.table.show') }}</span>
                <div v-if="showLegalInfo" class="rsya-item-info__legal">
                    <span v-html="$t('lang.report.rsy-ads.legal.title')"></span>
                    <span v-if="ad.legal" v-text="ad.legal" class="w400"></span>
                    <span v-else class="rsya-item-info__legal_empty">&mdash;</span>
                    <span @click="showLegalInfo = false" class="rsya-toogle-button rsya-toogle-button-collapse">{{ $t('lang.main.table.collapse') }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import RsyAdImgContainer from "./RsyAdImgContainer.vue";

export default {
    name: "AllRsyAd",
    components: {RsyAdImgContainer},
    computed: {
        groupLength() {
            if (!this.ad.group) {
                return 0;
            }

            return this.ad.group.length;
        }
    },
    data() {
        return {
            showAllLegalInfo: false,
            showLegalInfo: false,
        };
    },
    props: {
        ad: {
            type: Object,
            required: true
        },
        disableFancy: {
            type: Boolean,
            default: false,
        }
    },
    mounted() {
      this.$emitter.on('showAllLegalInfo', eventData => this.showLegalInfo = eventData);
    },
}
</script>

<style scoped>
    .rsy-item {
        height: 200px;
        border-radius: 5px;
    }
    .rsya-item__container {
        border-radius: 4px;
        background: #FFF;
        box-shadow: 2px 2px 10px 0 rgba(0, 0, 0, 0.10);
    }
    .rsy-item-title {
        padding: 0 8px;
    }
    .rsya-item-info__container {
        overflow: hidden;
        position: relative;
    }
    .rsya-item-info {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 4px 8px;
        gap: 15px;
        font-weight: 300;
    }
    .rsya-item-info__legal {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        top: 5px;
        display: flex;
        flex-direction: column;
        background-color: #fff;
        padding: 12px 8px;
        gap: 12px;
        border-radius: 0 0 4px 4px;
        box-shadow: 0 -2px 4px 0 rgba(0, 0, 0, 0.10);
    }
    .rsya-item-info__legal_empty {
        text-align: center;
    }
    .rsya-toogle-button {
        text-decoration: underline;
        text-align: right;
        color: #70B419;
        cursor: pointer;
    }
    .rsya-toogle-button-collapse {
        position: absolute;
        bottom: 0;
        right: 0;
        background: #ffffffab;
        padding: 8px;
        border-radius: 4px;
    }
    .rsya-item-info:nth-child(2n) {
        background: #EBF1F7;
    }
    .rsya-item-info span {
        font-size: 13px;
    }
    .rsy-item-titles {
        font-weight: 300;
        line-height: 140%;
    }
    .truncate_text {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .w400 {
        font-weight: 400;
    }

    .em95 {
        font-size: 0.95rem;
    }

    .em80 {
        font-size: 0.8rem;
    }

</style>
